// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(houseSize) {
  switch (houseSize) {
    case /* OneBhk */0 :
        return "1BHK";
    case /* TwoBhk */1 :
        return "2BHK";
    case /* ThreeBhk */2 :
        return "3BHK";
    case /* OneRk */3 :
        return "1RK";
    
  }
}

function fromString(houseSize) {
  var match = houseSize.toUpperCase();
  switch (match) {
    case "1BHK" :
        return /* OneBhk */0;
    case "2BHK" :
        return /* TwoBhk */1;
    case "3BHK" :
        return /* ThreeBhk */2;
    default:
      return /* OneRk */3;
  }
}

export {
  toString ,
  fromString ,
}
/* No side effect */
